/* ============================================================
   WASA Coffee -- v2 Touch Handler
   ------------------------------------------------------------
   On touch devices, CSS :hover is unreliable. This script
   implements the two-tap pattern described in the v2 brief:
     1. First tap on a card: reveals the bag + CTA
     2. Second tap on the CTA: fires add-to-cart (or navigates)
     3. Tap anywhere else on the page: collapses the card

   The bag reveal is purely a class toggle. All animation lives
   in wasa-v2-card.css under the @media (hover: none) block.

   This script is safe to include on all pages. It no-ops on
   devices with hover support.
   ============================================================ */

(function () {
  'use strict';

  // Only activate on devices without hover. On desktop, CSS
  // handles everything via :hover.
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(hover: none)');
  if (!mq.matches) return;

  var REVEALED_CLASS = 'fb-revealed';

  /**
   * Click handler. Delegates from document so newly-added cards
   * (e.g. from AJAX-paginated collections) are covered without
   * re-binding.
   */
  function onClick(e) {
    var card = e.target.closest('.fb-card');

    // If the tap was NOT on a card, collapse any revealed cards.
    if (!card) {
      collapseAll();
      return;
    }

    // If the tap was on the CTA button inside a revealed card,
    // let the normal click behavior happen (add to cart / link).
    var cta = e.target.closest('.fb-cta');
    if (cta && card.classList.contains(REVEALED_CLASS)) {
      // Let it through. The button's own click handler (or the
      // card's href) takes over.
      return;
    }

    // If the tap was on the CTA but the card is NOT revealed,
    // still treat this as a first tap on the card. Collapse other
    // cards first.
    if (cta && !card.classList.contains(REVEALED_CLASS)) {
      e.preventDefault();
      collapseAll();
      card.classList.add(REVEALED_CLASS);
      return;
    }

    // First tap on any other part of the card: prevent navigation,
    // reveal bag + CTA.
    if (!card.classList.contains(REVEALED_CLASS)) {
      e.preventDefault();
      collapseAll();
      card.classList.add(REVEALED_CLASS);
      return;
    }

    // Second tap on an already-revealed card (not on the CTA):
    // let the link navigate to the product page.
    // (Do nothing -- default action proceeds.)
  }

  function collapseAll() {
    var revealed = document.querySelectorAll('.fb-card.' + REVEALED_CLASS);
    for (var i = 0; i < revealed.length; i++) {
      revealed[i].classList.remove(REVEALED_CLASS);
    }
  }

  // ESC key collapses any revealed card (keyboard + screen reader users)
  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      collapseAll();
    }
  }

  document.addEventListener('click', onClick, { passive: false });
  document.addEventListener('keydown', onKeydown);
})();


/* ============================================================
   WASA -- Collection filter: force all vertical facet groups open
   ------------------------------------------------------------
   Luxe renders each filter category as a <details><summary>
   disclosure. We want them permanently expanded so shoppers see
   all checkboxes without having to click anything.

   Runs on DOMContentLoaded (covers the initial page load) and
   again on every facet AJAX update (Luxe dispatches a custom
   event after re-rendering the filter form).
   ============================================================ */

(function () {
  'use strict';

  function openAllFacets() {
    // NOTE: in Luxe v13, .facets__disclosure-vertical IS the <details> element.
    var details = document.querySelectorAll(
      'details.facets__disclosure-vertical'
    );
    for (var i = 0; i < details.length; i++) {
      details[i].open = true;
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openAllFacets);
  } else {
    openAllFacets();
  }

  // Re-open after Luxe AJAX filter re-renders
  document.addEventListener('facets:updated', openAllFacets);

  // MutationObserver fallback -- watches the filter sidebar for
  // DOM changes (Luxe may re-inject the details elements after
  // each filter selection).
  var filterContainer = document.getElementById('main-collection-filters');
  if (filterContainer && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      openAllFacets();
    });
    observer.observe(filterContainer, { childList: true, subtree: true });
  }
})();
